export default "__VITE_ASSET__Bl$$rMMK__"